import { Cropper } from 'vue-advanced-cropper';
import media_utility from './media_utility';

  export default {
  name: "crop_image_dialog",
  components: {
      Cropper
  },
  props:['showDialog', 'src'],
  data: () => ({
      img:'',
      canvas:false,
      checkOrientation:false,
      imageFile:{},
      stencilProps:{
        aspectRatio: 14/14
      },
      cropperShow:true,
      imageLoader:false,
      base64Image:'',
      getImgSrc: '',
      snackbar:false,
      err_msg:'',
      snackbar_color:''
  }),
  computed: {
    dialog:{
      get:function(){
        this.imageLoader = this.showDialog;
        return this.showDialog;
      },
      set:function(value){
        this.$emit("dialogClose", value);
      }
    }
  },
  mounted() {
  },
  methods: {
    /**
     * change
     * 
     */   
    change(e) {
      if(e.canvas){
        this.imageLoader = true; 
        var canvas = e.canvas;
        this.img = canvas.toDataURL("image/*");
        this.imageFile = this.convertCanvasImageToFile(canvas.toDataURL("image/*"));
        this.imageLoader = false;
      }
      
    },
    /**
     * convertCanvasImageToFile
     * 
     */
    convertCanvasImageToFile(dataURL){
      var blobBin = atob(dataURL.split(',')[1]);
      var array = [];
      for(var i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
      }
      var file=new Blob([new Uint8Array(array)], {type: 'image/*'});
      return file;
    },
    /**
     * close_dialog_with_original_img
     * 
     */    
    close_dialog_with_original_img(){
      // this.cropperShow = false;
      // this.img = this.getImgSrc;
      // this.$emit('getImageSrc', this.img);
      // this.$emit('getImageFile', this.imageFile);
      // this.cropperShow = true;
      this.dialog=false;
    },
    /**
     * done_crop_image
     * 
     */  
    done_crop_image(){
      this.$emit('getImageSrc', this.img);
      this.$emit('getImageFile', this.imageFile);
      this.dialog=false;
    },
    /**
     * ready
     * 
     */    
    ready(){
      this.imageLoader = false;
    },
    /**
     * rotateImage
     * 
     */
    rotateImage() {
      var image = document.createElement("img");
      image.crossOrigin = "anonymous";
      image.src = this.getImgSrc;
      image.onload = () => {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        if (image.width > image.height) {
          canvas.width = image.height;
          canvas.height = image.width;
          ctx.translate(image.height, image.width / image.height);
        } 
        else {
          canvas.height = image.width;
          canvas.width = image.height;
          ctx.translate(image.height, image.width / image.height);
        }
        
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, 0, 0); 
        this.getImgSrc  = canvas.toDataURL();
      };
    },
    /**
     * createBase64Image
     * 
     */
    createBase64Image(){
      var reader = new FileReader();
      reader.onload = (e) =>{
        this.base64Image = e.target.result;
      };
      reader.readAsDataURL(this.src);
    },
    /**
     * bytesToSize
     * 
     */
    bytesToSize(bytes) {
      return Math.round(bytes / Math.pow(1024, 2), 2);
    }
  },/*method closure */
  watch: {
    /**
     * src
     */
    src: async function (src) {
      if(src){
        let fileSize = this.bytesToSize(src.size);
        
        if(fileSize > process.env.VUE_APP_FILE_IMAGE_SIZE_LIMIT ){
          this.snackbar = true;
          this.err_msg = 'Image size should be less then '+process.env.VUE_APP_FILE_IMAGE_SIZE_LIMIT+'MB';
          this.snackbar_color='error';
          this.dialog=false;
          return false;
        }
        
        if(fileSize <= 1){ 
          //1 in MB if image size allready small and small then 2 MB then image will not be compressed
          this.getImgSrc =  URL.createObjectURL(src);
          this.imageFile = src;
        }
        else{
          let imgSrc =  URL.createObjectURL(src);
          let compressed_file = await media_utility.compress(imgSrc, src.name);
          this.getImgSrc  = compressed_file.url;
          this.imageFile  = compressed_file.file;
        }
      }
    }
  }
}
